import Vue from 'vue';

export default {
  // 获取合作伙伴
  getPartnerList(params) {
    return Vue.axios.get('/api/v1.0/system/company/partner/list', {params});
  }
};
